<script lang="ts" setup>
import { isStaging } from '@/modules/firebase'
</script>

<template>
    <div
        class="staging-banner"
        v-if="isStaging"
    >
        <span>STAGING MODE</span>
    </div>
</template>

<style scoped>
.staging-banner {
    background: linear-gradient(
        135deg,
        rgba(255, 205, 0, 0.4) 25%,
        rgba(154, 122, 0, 0.4) 25%,
        rgba(154, 122, 0, 0.4) 50%,
        rgba(255, 205, 0, 0.4) 50%,
        rgba(255, 205, 0, 0.4) 75%,
        rgba(154, 122, 0, 0.4) 75%,
        rgba(154, 122, 0, 0.4) 100%
    );
    color: #000000;
    background-size: 40px 40px;
    animation: diagonal-stripes 3s linear infinite;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    padding: 4px;
    height: 32px;
    box-sizing: border-box;
    pointer-events: none;
    font-size: 13px;
    z-index: 1000;
}

@keyframes diagonal-stripes {
    0% {
        background-position: 0 0;
    }
    100% {
        background-position: 40px 40px;
    }
}
</style>
